import { render, staticRenderFns } from "./cmp.vue?vue&type=template&id=722a69e0&scoped=true&lang=pug&"
import script from "./cmp.js?vue&type=script&lang=js&"
export * from "./cmp.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722a69e0",
  null
  
)

export default component.exports